export const environment = {
  production: false,
  API_HOST:
    localStorage.getItem("api_url") ||
    "https://chps-dev.azurewebsites.net/api/",
};
